/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoMarketCarTransactionLogListRequest model module.
 * @module model/LogControllerDtoMarketCarTransactionLogListRequest
 * @version 1.0
 */
class LogControllerDtoMarketCarTransactionLogListRequest {
    /**
     * Constructs a new <code>LogControllerDtoMarketCarTransactionLogListRequest</code>.
     * @alias module:model/LogControllerDtoMarketCarTransactionLogListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        LogControllerDtoMarketCarTransactionLogListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>LogControllerDtoMarketCarTransactionLogListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoMarketCarTransactionLogListRequest} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoMarketCarTransactionLogListRequest} The populated <code>LogControllerDtoMarketCarTransactionLogListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoMarketCarTransactionLogListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('buyerAccount')) {
                obj['buyerAccount'] = ApiClient.convertToType(data['buyerAccount'], 'String');
            }
            if (data.hasOwnProperty('sellerAccount')) {
                obj['sellerAccount'] = ApiClient.convertToType(data['sellerAccount'], 'String');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('vehicleType')) {
                obj['vehicleType'] = ApiClient.convertToType(data['vehicleType'], 'Number');
            }
            if (data.hasOwnProperty('vehicleGrade')) {
                obj['vehicleGrade'] = ApiClient.convertToType(data['vehicleGrade'], 'String');
            }
            if (data.hasOwnProperty('vehicleSeal')) {
                obj['vehicleSeal'] = ApiClient.convertToType(data['vehicleSeal'], 'String');
            }
            if (data.hasOwnProperty('minLevel')) {
                obj['minLevel'] = ApiClient.convertToType(data['minLevel'], 'Number');
            }
            if (data.hasOwnProperty('maxLevel')) {
                obj['maxLevel'] = ApiClient.convertToType(data['maxLevel'], 'Number');
            }
            if (data.hasOwnProperty('isPlus')) {
                obj['isPlus'] = ApiClient.convertToType(data['isPlus'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoMarketCarTransactionLogListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoMarketCarTransactionLogListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of LogControllerDtoMarketCarTransactionLogListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['buyerAccount'] && !(typeof data['buyerAccount'] === 'string' || data['buyerAccount'] instanceof String)) {
            throw new Error("Expected the field `buyerAccount` to be a primitive type in the JSON string but got " + data['buyerAccount']);
        }
        // ensure the json data is a string
        if (data['sellerAccount'] && !(typeof data['sellerAccount'] === 'string' || data['sellerAccount'] instanceof String)) {
            throw new Error("Expected the field `sellerAccount` to be a primitive type in the JSON string but got " + data['sellerAccount']);
        }
        // ensure the json data is a string
        if (data['vehicleGrade'] && !(typeof data['vehicleGrade'] === 'string' || data['vehicleGrade'] instanceof String)) {
            throw new Error("Expected the field `vehicleGrade` to be a primitive type in the JSON string but got " + data['vehicleGrade']);
        }
        // ensure the json data is a string
        if (data['vehicleSeal'] && !(typeof data['vehicleSeal'] === 'string' || data['vehicleSeal'] instanceof String)) {
            throw new Error("Expected the field `vehicleSeal` to be a primitive type in the JSON string but got " + data['vehicleSeal']);
        }

        return true;
    }


}

LogControllerDtoMarketCarTransactionLogListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
LogControllerDtoMarketCarTransactionLogListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
LogControllerDtoMarketCarTransactionLogListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
LogControllerDtoMarketCarTransactionLogListRequest.prototype['skip'] = undefined;

/**
 * @member {Date} beginDate
 */
LogControllerDtoMarketCarTransactionLogListRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
LogControllerDtoMarketCarTransactionLogListRequest.prototype['endDate'] = undefined;

/**
 * @member {String} buyerAccount
 */
LogControllerDtoMarketCarTransactionLogListRequest.prototype['buyerAccount'] = undefined;

/**
 * @member {String} sellerAccount
 */
LogControllerDtoMarketCarTransactionLogListRequest.prototype['sellerAccount'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoMarketCarTransactionLogListRequest.prototype['nftUid'] = undefined;

/**
 * @member {Number} vehicleType
 */
LogControllerDtoMarketCarTransactionLogListRequest.prototype['vehicleType'] = undefined;

/**
 * @member {String} vehicleGrade
 */
LogControllerDtoMarketCarTransactionLogListRequest.prototype['vehicleGrade'] = undefined;

/**
 * @member {String} vehicleSeal
 */
LogControllerDtoMarketCarTransactionLogListRequest.prototype['vehicleSeal'] = undefined;

/**
 * @member {Number} minLevel
 */
LogControllerDtoMarketCarTransactionLogListRequest.prototype['minLevel'] = undefined;

/**
 * @member {Number} maxLevel
 */
LogControllerDtoMarketCarTransactionLogListRequest.prototype['maxLevel'] = undefined;

/**
 * @member {Boolean} isPlus
 */
LogControllerDtoMarketCarTransactionLogListRequest.prototype['isPlus'] = undefined;






export default LogControllerDtoMarketCarTransactionLogListRequest;

